import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Resources from "../pages/resources/page";
import News from "../pages/news/page";
import FAQ from "../pages/faq/page";
import SearchResults from "../pages/search/page";
import Contact from "../pages/contact/page";
import FrHome from "../pages/fr-home/page";
import FrResources from "../pages/fr-resources/page";
import FrNews from "../pages/fr-news/page";
import FrFAQ from "../pages/fr-faq/page";
import FrSearch from "../pages/fr-search/page";
import FrContact from "../pages/fr-contact/page";

const routes: RouteObject[] = [
  // English routes
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/search",
    element: <SearchResults />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  // French routes
  {
    path: "/fr",
    element: <FrHome />,
  },
  {
    path: "/fr/resources",
    element: <FrResources />,
  },
  {
    path: "/fr/news",
    element: <FrNews />,
  },
  {
    path: "/fr/faq",
    element: <FrFAQ />,
  },
  {
    path: "/fr/search",
    element: <FrSearch />,
  },
  {
    path: "/fr/contact",
    element: <FrContact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;